<template>
  <div>

    <div class="row">
      <div class="col-md-12 col-sm-12 ">
        <div class="">
          <div class="x_panel">
            <h2 class="float-left">Requisition Reports</h2>
            <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
              <button
                v-if="reportData && isPermissionExist(PERMISSIONS.REQUISITION_REPORT_PRINT)"
                @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                <i class="fa fa-print" v-if="!isPrinting"></i>
                <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                {{ isPrinting ? 'Printing...' : 'Print' }}
              </button>
              <vue-excel-xlsx
                v-if="reportData && isPermissionExist(PERMISSIONS.REQUISITION_REPORT_PRINT)"
                ref="excel"
                :data="excelData"
                :columns="excelHeader"
                :file-name="'Requisition Report List'"
                :file-type="'xlsx'"
                :sheet-name="'sheetname'"
                :disabled="isPrinting"
                class="btn btn-primary btn-sm float-right"
              >
                <div
                  @click.prevent="handleExportPrint('excel')"
                >
                  <i class="fa fa-file-excel-o"></i>
                  {{ isPrinting ? 'Preparing...' : 'Excel' }}
                </div>
              </vue-excel-xlsx>
          </div>
          <div class="row">
            <div class="col-sm-12">
                <div class="x_panel">
                  <div class="x_content">
                    <div class="row justify-content-center">
                      <div class="col-md-2">
                        <div class="form-group">
                          <label>Vessel</label>
                          <select class="form-control" v-model="formData.vessel">
                            <option value="" selected>Select Vessel</option>
                            <option v-for="(row, key) in vessels" v-bind:value="{ id: row?.id, name: row?.name }">{{row?.name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-2 mx-2">
                        <div class="form-group">
                          <label>Date From</label>
                          <DatePicker type="date" v-model="formData.dateFrom" valueType="format"></DatePicker>
                        </div>
                      </div>
                      <div class="col-md-2 mx-2">
                        <div class="form-group">
                          <label>Date To</label>
                          <DatePicker type="date" v-model="formData.dateTo" valueType="format"></DatePicker>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <button style="margin-top: 26px" class="btn-info btn btn-sm" @click="formSubmit()">Search</button>
                      </div>
                    </div>
                  </div>
                </div>
              <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
                <PulseLoader :loading="loading"></PulseLoader>
              </div>
              <div class="card-box table-responsive" v-if="reportData && !loading">
                <div class="clearfix"></div>
                <div id="printableArea">
                  <div class="mb-3 text-center">
                    <div class="font-weight-bold">Requisition Report</div>
                    <div v-if="formData.vessel.name != ''">Vessel:
                      <span>{{formData.vessel.name}}  </span>
                    </div>
                    <div v-if="formData.dateFrom != '' && formData.dateTo !=''">
                      Date Period:
                      <span v-if="formData.dateFrom">{{ formData.dateFrom | moment('DD/MM/YYYY') }}</span> -
                      <span v-if="formData.dateTo"> {{ formData.dateTo | moment('DD/MM/YYYY') }}</span>
                    </div>
                  </div>

                  <PerPageSelector v-model="offset" @change="onPerPageChange"/>
                  <TableData :reportData="reportData?.data"
                             :currentPage="Number(reportData?.current_page)"
                             :perPage="Number(reportData?.per_page)"
                             :show="show">

                  </TableData>
                  <Pagination :pagination="reportData" :getData="formSubmit"/>

                  <div id="printArea" style="display: none">
                    <div style="text-align: center;line-height: 20px;">
                      <h2 style="line-height: 10px;">{{ appName }}</h2>
                      <h3 style="line-height: 10px;">Requisition Reports</h3>
                      <h3 style="line-height: 10px;">Vessel: <span v-if="formData.vessel">{{formData.vessel.name}}</span></h3>
                      <h3 style="line-height: 10px;" v-if="formData.dateFrom != '' && formData.dateTo !=''">
                        Date Period: <span v-if="formData.dateFrom">{{ formData.dateFrom | moment('DD/MM/YYYY') }}</span> -
                        <span v-if="formData.dateTo"> {{ formData.dateTo | moment('DD/MM/YYYY') }}</span>
                      </h3>
                      <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>

                    </div>
                    <TableData :reportData="printItems" :isPrinting="true"></TableData>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Requisition view Modal -->
    <div class="modal fade" id="requisitionModal" tabindex="-1" role="dialog" aria-labelledby="requisitionModalTitle" aria-hidden="true">
      <div class="modal-dialog mw-100 w-75" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="requisitionModalTitle">Requisition Item </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <button @click="print('printModalArea','Requisition Item')" class="btn btn-warning btn-sm float-left"><i class="fa fa-print"></i> Print</button>
          </div>
          <div class="modal-body" v-if="requisitionItem">
            <ModalData :requisitionItem="requisitionItem"></ModalData>
            <div id="printModalArea" style="display: none;">
              <div style="text-align: center">
                <h2 style="line-height: 10px;">{{ appName }}</h2>
                <h3 style="line-height: 10px;">Requisition Item</h3>
                <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
              </div>
              <ModalData :requisitionItem="requisitionItem" :isPrinting="true"></ModalData>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Requisition view Modal -->
  </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker'
    import auth from '../../../auth'
    import TableData from "@/components/reports/Requisition/TableData.vue";
    import ModalData from "@/components/reports/Requisition/ModalData.vue";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import exportMixin from "@/mixin/exportMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import {apiPrintData} from "@/utils/print";
    import permissionsMixin from "@/mixin/permissionsMixin";

    export default {
        mixins: [printMixin, goBackButtonMixin, exportMixin, permissionsMixin],
        components: {ModalData, TableData, DatePicker, PulseLoader},
        data() {
            return {
                loading: false,
                isPrinting: false,
                formData: {
                    vessel: {
                        id: auth.getVesselId(),
                        name: ''
                    },
                    dateFrom: '',
                    dateTo: '',
                },
                appName: process.env.VUE_APP_NAME,
                requisitionItem: null,
                vessels: null,
                reportData: null,
                noDataFound: null,
                offset: 20,
                vesselId: auth.getVesselId(),
                permissions: auth.getPermissionData(),
                printItems: [],
                excelHeader: [],
                excelData: [],
            }
        },
        mounted() {
            this.getVessel();
            this.formSubmit();
        },
        methods: {
            getVessel() {
              let params = {
                is_all: 1
              }
                this.$http.get('/api/vessel', {params}).then(response => {
                    this.vessels = response.data.success.vessel
                  const selectedVessel = this.vessels.find(vessel => vessel.id == this.vesselId);
                  if (selectedVessel) {
                    this.formData.vessel = {
                      id: selectedVessel.id,
                      name: selectedVessel.name
                    };
                  }
                }).catch(e => {
                    console.log(e)
                })
            },

            onPerPageChange() {
              this.formSubmit(1);
            },
          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Date': `${item?.date || ''}`,
                'Requisition no': `${item?.requisition_no || ''}`,
                'Title': `${item?.title || ''}`,
                'Priority': `${item?.priority || ''}`,
                'Remarks': `${item?.remarks || ''}`,
                'Created By': `${item?.user?.username || ''}`,
                'Engr. Approval': `${item?.chief_engr_approval || ''}`,
                'Super. Approval': `${item?.superintendent_approval || ''}`,
                'TM Approval': `${item?.technical_manager_approval || ''}`,
              });
            });

            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                vessel_id: this.formData.vessel_id,
                date_from: this.formData.dateFrom,
                date_to: this.formData.dateTo,
                is_all: 1,
              };

              const res = await this.$http.get('/api/report/requisition', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Requisition Report List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },

            async handlePrint() {
              this.isPrinting = true;

              try {
                const params = {
                  vessel_id: this.formData.vessel_id,
                  date_from: this.formData.dateFrom,
                  date_to: this.formData.dateTo,
                  is_all: 1,
                };

                const res = await this.$http.get('/api/report/requisition', {params});
                this.printItems = res?.data?.success ?? [];

                this.$nextTick(() => {
                  apiPrintData('printArea', 'Requisition Report List');
                  this.isPrinting = false;
                });

              } catch (error) {
                this.isPrinting = false;
                printWindow.close();
              }
            },
            formSubmit(page = 1) {
                this.loading = true;
                if (this.formData.vessel) this.formData.vessel_id = this.formData.vessel.id
                let params = {
                    vessel_id: this.formData.vessel_id,
                    date_from: this.formData.dateFrom,
                    date_to: this.formData.dateTo,
                    is_all: 0,
                    page: page,
                    offset: this.offset,
                };
                this.$http.get('/api/report/requisition', {params}).then((response) => {
                    this.loading = false;
                    this.reportData = response.data.success;
                }).catch((error) => {
                    this.loading = false;
                    let response = error.response;
                    if (response?.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {

                    }
                })
            },
            show(item) {
                this.$http.get('/api/requisition/' + item).then(response => {
                    this.requisitionItem = response.data;
                    $('#requisitionModal').modal('show')
                }).catch(e => {
                    console.log(e)
                })
            },
        }
    }
</script>

<style scoped>

</style>
